export default function CTASection() {
  return (
    <section id="cta" className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20red%20and%20golden%20abstract%20gradient%20background%20with%20soft%20glowing%20particles%2C%20luxurious%20Chinese%20festive%20atmosphere%2C%20celebration%20theme%2C%20elegant%20minimalist%20design%2C%20cinematic%20lighting%2C%20soft%20bokeh&width=1600&height=600&seq=cta-bg-home&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-primary-800/90 to-primary-900/85"></div>

      <div className="relative z-10 max-w-[700px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
          立即参与送彩金活动
        </h2>
        <p className="text-background-200 text-sm md:text-base mb-8 leading-relaxed">
          注册即可领取专属彩金，多种送彩金方式任你选择。彩金到账快速，提款无忧，快来赢取更多奖励！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="#"
            className="bg-accent-500 hover:bg-accent-600 text-background-50 px-8 py-3 rounded-full text-base font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer w-full sm:w-auto"
          >
            立即注册领取彩金
          </a>
          <a
            href="#faq"
            className="bg-background-50/10 backdrop-blur-sm hover:bg-background-50/20 text-background-50 border border-background-50/30 px-8 py-3 rounded-full text-base font-medium transition-all duration-200 whitespace-nowrap cursor-pointer w-full sm:w-auto"
          >
            了解更多
          </a>
        </div>
      </div>
    </section>
  );
}